import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { type ErrorRouteComponent, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { Button } from 'components/atoms/Button';
import { ErrorPage } from 'components/organisms/ErrorPage';
import { useLocalization } from 'providers/LocalizationProvider';
import { rumService } from 'services/rum';

import * as S from './DefaultError.style';

export function DefaultError({
  info,
}: React.ComponentProps<ErrorRouteComponent>) {
  const { t } = useLocalization('uncaught_error_page');
  const router = useRouter();
  const queryErrorResetBoundary = useQueryErrorResetBoundary();

  useEffect(() => {
    queryErrorResetBoundary.reset();
  }, [queryErrorResetBoundary]);

  return (
    <ErrorPage
      title={t('title')}
      subtitle={t('subtitle')}
      illustration={<S.DefaultErrorIllustration />}
    >
      <Button
        onClick={() => {
          rumService.addAction('user retry from default error', info);
          router.invalidate().catch(() => window.location.reload());
        }}
        size="large"
      >
        {t('cta')}
      </Button>
    </ErrorPage>
  );
}
